import { getAuth, onAuthStateChanged } from "firebase/auth";

export const refreshToken = async (): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        user
          .getIdToken(true)

          .then((token) => {
            localStorage.setItem("accessToken", token);
            resolve(token);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
        reject("No user signed in");
      }
    });
  });
};
